import React from "react";

export default function PresenceDot({ online = false, className = "" }) {
  return (
    <span
      className={`inline-block w-2 h-2 rounded-full ${
        online ? "bg-green-400" : "bg-gray-600"
      } ${className}`}
    />
  );
}
